/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import { connect, useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { isEmpty } from 'lodash'

import ScanQRGif from '../assets/gifs/scan-qr.gif'

import GratuityHeader from '../components/GratuityHeader'
import SegmentedControlV2 from '../components/segmentedControl/SegmentedControl'
import VNLoader from '../VNLoader/components/VNLoader'
import useCreateOrderInProgress from '../hooks/useCreateOrderInProgress'
import useGetQRBalance, { QR_PAY_ERROR_MESSAGE } from '../hooks/useGetQRBalance'
import { getOrder, getOrderInProgress, getQRPayAuthError } from '../selectors/order'
import { centsToDollars } from '../utils/formatters'
import PeripheralBridge from '../utils/peripheralBridge'
import { KEY_CODES } from '../kiosk/utils/constants'
import {
  addPaymentToOrderInProgress,
  clearOrderInProgress,
  closeNoOpTender,
  setOrderInProgressWithId,
  removeQRPaymentandAuthorizationFailedStatus,
  setQRPayAuthError,
  restoreQRPaymentandAuthorizationFailedStatus,
  clearTipOrderInProgress,
  cancelRemovePayment,
  clearTipFromOrder,
  updateOrderInProgress,
} from '../actions/order'
import styles from './ScanScreen.module.scss'
import { getDeviceMode } from '../VNMode/Selectors'
import { MODES } from '../VNMode/Reducer'
import { sendCFDScreenNav } from '../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_SCREEN } from '../VNCustomerFacingDisplay/Reducer'
import VNConcessionsNavBar from '../components/VNConcessionsNavBar'
import useGetIsMobileScreen from '../hooks/useGetIsMobileScreen'
import { setCurrentPaymentFlow } from '../VNCustomerFacingDisplay/ActionCreators'
import { VNPPI_TENDERS, VNPPI_TENDERS_KEY } from '../VNPPI/Enums'
import { handleBalanceLookup, handleFullPpiFlow } from '../VNPPI/Utils'
import { MobileScanner } from '../VNMobileScanner/components/MobileScanner'
import { CameraAlt } from '@material-ui/icons'
import { CFD_POS_PAYMENT_FLOWS } from '../VNCustomerFacingDisplay/Enums'
import { getCameraPermissions, getVNScannerInitialized, getVNScannerResults } from '../VNMobileScanner/Selectors'
import ConfirmModalV2 from '../components/ConfirmModalV2'
import { VNInjectablePpi } from '../VNPPI/containers/VNInjectablePpi'
import { codeAlreadyUsed } from '../VNUtil/VNUtils'
import { isTabbed } from '../utils/orderStates'
import { ToastManager } from '../utils/toastManager'
import useCloseFreeOrder from '../hooks/useCloseFreeOrder'
import { toastError } from '../utils/scanScreen'
import { APPLICATION_STRINGS } from '../strings'
import { setBalanceLookupDialogOptions } from '../VNDialogs/ActionCreators'
import { floatToDollars } from '../VNUtil/Money'
import { PAYMENT_TYPES } from '../utils/paymentTypes'
import useSpinner from '../context/hooks/useSpinner'
import { useAuths } from '../VNTenders/hooks/useAuths'
import { useSyncOrders } from '../VNOrders/hooks/useSync'
import { getIsPreAuthTab } from '../utils/orderUtils'
import { getUseTaxClasses } from '../selectors/menus'
import { getIsOrderTaxExempt } from '../VNTaxes/Selectors'

const QRChoices = [
  { label: 'Scan Code', value: 'scan' },
  { label: 'Type Code', value: 'entry' },
]

const QRPay = ({
  className,
  onGoBack,
  needCreateOrder,
  fromBalanceLookup,
  order,
  addPaymentToOrderInProgress,
  balanceDueInCents,
  placeFreeOrder,
  push,
  tabOrderInState,
  tipAmount,
  charityAmount,
}) => {
  const classNames = cn(styles.scanScreen, className)
  const isMobile = useGetIsMobileScreen()
  const [selectedSubmissionType, setSelectedSubmissionType] = useState(isMobile ? 'entry' : 'scan')
  const [isProcessing, setIsProcessing] = useState(false)
  const [qrCode, setQRCode] = useState('')
  const [ppiInitialized, setPpiInitialized] = useState(false)
  const [createOrder, orderCreated] = useCreateOrderInProgress(order?.uuid, fromBalanceLookup)
  const [
    getQRBalance,
    { qrBalance, vaultedCard, dataSucceeded, dataFailed, isExpired, affiliationUuids, userUuid, resetQRState },
  ] = useGetQRBalance()
  const [keyboardIsActive, setKeyboardIsActive] = useState(false)
  const [retotalingOrder, setRetotalingOrder] = useState(false)
  const [mobileScannerEnabled, setMobileScannerEnabled] = useState(true)
  const [codeError, setCodeError] = useState(false)
  const [scannerLive, setScannerLive] = useState(false)
  const isTabOrder = isTabbed(order)
  const { closeFreeOrder } = useCloseFreeOrder()
  const { startSpinner, stopSpinner, showSpinner } = useSpinner()
  const { stashAuthPaymentForLaterUse } = useAuths()
  const { syncOrderWithAuthIfNeeded } = useSyncOrders()
  const useTaxClasses = useSelector(getUseTaxClasses)
  const hasNoBalance = +qrBalance === 0 && !vaultedCard

  const taxExempt = useSelector(getIsOrderTaxExempt)

  const ppiInjectableRef = useRef()

  const qrCodeRef = useRef()

  const currentOrder = useRef()

  const dispatch = useDispatch()
  const mobileScanResults = useSelector((state) => getVNScannerResults(state))
  const isMobileScannerInitialized = useSelector((state) => getVNScannerInitialized(state))
  const isCameraPermissionAllowed = useSelector((state) => getCameraPermissions(state))
  const cfdMode = useSelector((state) => getDeviceMode(state))
  let enterKeyPressed = false // because POS is sometimes slow, pressing enter twice will apply discounts twice and mess totaling up.

  const QRPayAuthError = useSelector((state) => getQRPayAuthError(state))

  /**
   * This should be only called once, calling it more than one time causes lag.
   * Android has fixed this in APK 2.16.0 but legacy versions still have this issue so be careful.
   */
  const stopScanner = () => {
    const bridgeInstance = PeripheralBridge.getBridge()

    if (!bridgeInstance) return
    if (!scannerLive) return

    setScannerLive(false)
    bridgeInstance.call('stopScanner')
  }

  const closeKeyBoard = () => {
    if (keyboardIsActive) {
      qrCodeRef?.current?.blur()
    }
  }

  const handleFocusChange = () => {
    setTimeout(() => {
      setKeyboardIsActive(document.activeElement === qrCodeRef?.current)
    }, 150)
  }

  useEffect(() => {
    dispatch(setQRPayAuthError(false))

    if (needCreateOrder) {
      createOrder(null, userUuid, null, tipAmount, charityAmount)
    }
    enterKeyPressed = false
    document.addEventListener('focusin', handleFocusChange)
    document.addEventListener('focusout', handleFocusChange)

    return () => {
      stopScanner()
      document.removeEventListener('focusin', handleFocusChange)
      document.removeEventListener('focusout', handleFocusChange)
    }
  }, [])

  // sync offline auth tabs before processing
  useEffect(() => {
    const syncCurrentOrder = async () => {
      if (!getIsPreAuthTab(order)) return false

      // stash payment if order was already created in stadium
      if (order?.wasCreatedInStadium) {
        stashAuthPaymentForLaterUse(false)
        return
      }

      startSpinner()
      try {
        await syncOrderWithAuthIfNeeded(true, false)
      } catch (error) {
        console.error('Error syncing order:', error)
      } finally {
        stopSpinner()
      }
    }
    if (showSpinner) {
      stopSpinner()
    }

    syncCurrentOrder()
    return stopSpinner
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (dataFailed) {
      setCodeError(true)
      setIsProcessing(false)
      if (isExpired) {
        toastError('QR code has expired. Please refresh your code and try again', isMobile)
      } else {
        toastError(QR_PAY_ERROR_MESSAGE, isMobile)
      }
    }
  }, [dataFailed])

  useEffect(() => {
    //In case a new order is created we need to store uuid and balanceDueInCents
    currentOrder.current = {
      uuid: order.uuid,
      balanceDueInCents: order?.balanceDueInCents || currentOrder.current?.balanceDueInCents || 0,
    }

    if ((orderCreated || isTabOrder) && order?.amountInCents === 0 && !retotalingOrder) {
      closeFreeOrder(order.uuid, isTabOrder)
      return
    }
    if (retotalingOrder && orderCreated) {
      setRetotalingOrder(false)
      handleSuccess()
    }
  }, [orderCreated, isTabOrder])

  useEffect(() => {
    if (fromBalanceLookup) {
      sendCFDScreenNav(CFD_SCREEN.PRESENT_QR_PAY_CODE)
    }
  }, [])

  useEffect(() => {
    if (!dataSucceeded) return

    if (!isEmpty(affiliationUuids) || !isTabbed(order)) {
      createOrder(true, userUuid, affiliationUuids, order?.tipAmountInCents, order?.charityAmountInCents)
      setRetotalingOrder(true)
      return
    }

    if (hasNoBalance) {
      // eslint-disable-next-line no-unused-vars
      const [_, redirectToSplit] = getTenderAmountAndRedirect()
      dispatch(updateOrderInProgress({ userUuid }))

      if (cfdMode === MODES.POS && !redirectToSplit) return
      if (redirectToSplit) {
        ToastManager.success('Scan QR code successful')
        redirect(balanceDueInCents - qrBalance)
      }

      return
    }

    handleSuccess()
  }, [dataSucceeded])

  useEffect(() => {
    if (selectedSubmissionType === 'entry' && qrCodeRef.current) {
      setScannerLive(false)
      qrCodeRef.current?.focus()
    }
  }, [selectedSubmissionType])

  useEffect(() => {
    const bridgeInstance = PeripheralBridge.getBridge()

    if (selectedSubmissionType === 'scan' && ppiInitialized) {
      if (!bridgeInstance) return
      setScannerLive(true)
      bridgeInstance.registerHandler('scanPayload', function (data, callback) {
        const scannedCode = data?.valueOf()
        if (codeAlreadyUsed(order, scannedCode)) {
          toastError('QR code already scanned and applied to order', isMobile)
          return
        }

        if (fromBalanceLookup) {
          checkBalance(scannedCode)
          return
        }

        setQRCode(scannedCode)
        startBalanceCheck(scannedCode)
      })

      bridgeInstance.registerHandler('scanError', function (err, callback) {
        if (err?.toLowerCase()?.includes('no scanner detected')) {
          setSelectedSubmissionType('entry')
        }
        setCodeError(true)
        toastError(`QR code scan error, ERROR: ${JSON.stringify(err)}`, isMobile)
      })
    }
  }, [selectedSubmissionType, ppiInitialized])

  useEffect(() => {
    if (mobileScanResults && mobileScanResults?.get('results')) {
      onMobileScan(mobileScanResults?.get('results'))
    }
  }, [mobileScanResults])

  useEffect(() => {
    const bridgeInstance = PeripheralBridge.getBridge()
    if (!bridgeInstance) return

    if (isProcessing || selectedSubmissionType === 'entry') {
      stopScanner()
      setScannerLive(false)
    } else if (selectedSubmissionType === 'scan' && ppiInitialized) {
      bridgeInstance.call('startScanner')
      setScannerLive(true)
    }
  }, [isProcessing, selectedSubmissionType, ppiInitialized])

  //Set current order with the first valid value once order in progress has been set
  useEffect(() => {
    if (!currentOrder?.current?.uuid) {
      currentOrder.current = {
        uuid: order.uuid,
        balanceDueInCents: order?.balanceDueInCents,
      }
    }
  }, [order])

  /**
   * This code will be triggered when QRPayAuthError is set to true
   * then we asume that a QRPay failed for the order being processed
   */
  useEffect(() => {
    //if QRPayAuthError is false then return, this will prevent undesired re renders
    if (!QRPayAuthError) {
      return
    }

    setCodeError(true)
    resetTicket()
    toastError(QR_PAY_ERROR_MESSAGE, isMobile)

    const orderId = currentOrder.current.uuid

    //dispatch action to set the order into syncable status
    dispatch(removeQRPaymentandAuthorizationFailedStatus({ orderId, balanceDueInCents: currentOrder.current.balanceDueInCents }))
    dispatch(setOrderInProgressWithId(orderId))
  }, [QRPayAuthError])

  const resetTicket = () => {
    setQRCode('')
    setIsProcessing(false)
  }

  const primaryText = fromBalanceLookup
    ? APPLICATION_STRINGS.AVAILABLE_BALANCE_TITLE
    : centsToDollars(balanceDueInCents !== 0 ? balanceDueInCents : order?.amountInCents)
  const secondaryText = selectedSubmissionType === 'scan' ? 'Please scan QR code' : 'Please type QR Pay code'

  const handleSubmissionTypeChange = (value) => {
    if (selectedSubmissionType !== value) {
      setSelectedSubmissionType(value)
    }
  }

  const redirect = (tenderAmountInCents) => {
    if (cfdMode === MODES.POS) {
      sendCFDScreenNav(CFD_SCREEN.BALANCE_DUE, {
        balanceToBePaid: { amountPaid: order?.amountInCents - tenderAmountInCents, balanceDue: tenderAmountInCents },
      })
    }

    push({
      pathname: '/tender-selection',
      state: {
        tenderAmountInCents,
        previousPaymentType: PAYMENT_TYPES.QR_PAY,
        fromSplit: true,
      },
    })
  }

  /**
   *
   * @param {*} code
   */
  const startBalanceCheck = async (code) => {
    setIsProcessing(true)
    resetQRState()

    const ppiInjectableData = ppiInjectableRef.current?.getData(VNPPI_TENDERS.QRPAY_TENDER)

    if (!isEmpty(ppiInjectableData?.ppiTender?.integration)) {
      const externalFunctionality = {
        functions: {
          ...ppiInjectableData.functions,
          setError: setCodeError,
          redirect: redirect,
          placeFreeOrder: placeFreeOrder,
        },
        balanceDueInCents: ppiInjectableData.order?.balanceDueInCents,
        promotions: ppiInjectableData.promotions,
        token: code,
        paymentType: VNPPI_TENDERS_KEY.QRPAY_TENDER,
        shortDescription: 'QR Pay',
        useTaxClasses,
        taxExempt: order?.taxExempt ?? taxExempt ?? false,
      }

      await handleFullPpiFlow(ppiInjectableData, externalFunctionality)

      resetTicket()
    } else {
      getQRBalance(code)
    }
  }

  // This only gets the balance and does nothing with the balance or order.
  // this is for the balance lookup screen
  const checkBalance = async (ticket) => {
    setIsProcessing(true)
    setCodeError(false)

    const ppiInjectableData = ppiInjectableRef.current.getData(VNPPI_TENDERS.QRPAY_TENDER)

    try {
      const data = await handleBalanceLookup(ppiInjectableData, ticket)
      const amount = data?.data?.balance

      if (amount === 0) {
        toastError(APPLICATION_STRINGS.AVAILABLE_BALANCE_LOOKUP_QR_PAY_FUND_ERROR, isMobile)
        return
      }

      if (cfdMode === MODES.POS) {
        sendCFDScreenNav(CFD_SCREEN.BALANCE_AVAILABLE, { availableBalance: `$${floatToDollars(amount)}` })
      }
      dispatch(
        setBalanceLookupDialogOptions({
          open: true,
          amount: `$${floatToDollars(amount)}`,
          previousScreen: CFD_SCREEN.PRESENT_QR_PAY_CODE,
        }),
      )
    } catch (error) {
      toastError(APPLICATION_STRINGS.AVAILABLE_BALANCE_LOOKUP_QR_PAY_SCAN_ERROR, isMobile)
    }

    resetTicket()
  }

  const getTenderAmountAndRedirect = () => {
    if (vaultedCard) {
      return [balanceDueInCents, false]
    }
    if (qrBalance >= balanceDueInCents) {
      return [balanceDueInCents, false]
    }

    return [qrBalance, true]
  }

  const handleSuccess = () => {
    const [tenderAmountInCents, redirectToSplit] = getTenderAmountAndRedirect()

    addPaymentToOrderInProgress({
      tenderAmountInCents,
      paymentType: 'wallet_nonce',
      shortDescription: 'QR Pay',
      token: qrCode,
    })

    if (cfdMode === MODES.POS && !redirectToSplit) return
    if (redirectToSplit) {
      ToastManager.success('Scan QR code successful')
      redirect(balanceDueInCents - qrBalance)
    }
  }

  const handleKeyPress = (e) => {
    if ((e.keyCode === KEY_CODES.ENTER || e.keyCode === '9' || e.key === 'ENTER' || e.key === 'Tab') && !enterKeyPressed) {
      enterKeyPressed = true
      // eslint-disable-next-line no-useless-escape
      const isValid = /^[a-z|0-9\-]*?$/gi.test(qrCode)
      if (!isValid) {
        toastError('The code entered contains invalid characters', isMobile)
        return
      }
      if (codeAlreadyUsed(order, qrCode)) {
        toastError('QR Code already entered and applied to order', isMobile)
        return
      }

      closeKeyBoard()

      // Enforce a slight delay to prevent the on screen keyboard from freezing
      // due to device resources being used for network calls and order processing.
      setTimeout(() => {
        if (fromBalanceLookup) {
          checkBalance(qrCode)
          return
        }
        startBalanceCheck(qrCode)
      }, 300)
    }
  }

  const onMobileCameraClick = () => {
    setMobileScannerEnabled(true)
  }

  const onMobileScan = (scanResult) => {
    if (codeAlreadyUsed(order, scanResult)) {
      toastError('QR code already scanned and applied to order', isMobile)
      return
    }

    if (fromBalanceLookup) {
      checkBalance(scanResult)
      return
    }

    setQRCode(scanResult)
    startBalanceCheck(scanResult)
  }

  const handleTicketCodeChange = (e) => {
    setQRCode(e?.target?.value)
  }

  if (!orderCreated && needCreateOrder && isProcessing && !fromBalanceLookup) {
    return <VNLoader />
  }

  const showTenderOptionButton = () => {
    if (fromBalanceLookup) return false

    return codeError && !isProcessing && !keyboardIsActive
  }

  const chooseTenderOptionButton = showTenderOptionButton() && (
    <div
      className={styles.chooseTenderOption}
      onClick={() => {
        redirect(balanceDueInCents)
      }}
    >
      Pay With Other Method
    </div>
  )

  const scanError = () => {
    if (codeError) {
      return (
        <ConfirmModalV2
          onButtonOneClick={() => {
            if (balanceDueInCents > 0) {
              redirect(balanceDueInCents)
            }
          }}
          onButtonTwoClick={() => {
            setCodeError(false)
          }}
          headerText={null}
          subtext={'There was an issue when scanning this QR code. Would you like to try again?'}
          isKiosk={false}
          buttonOneText={'OTHER TENDER'}
          buttonTwoText={'TRY AGAIN'}
        />
      )
    }

    return
  }

  const displayVNInjectablePpi = () => {
    return (
      <VNInjectablePpi
        onMount={() => {
          setPpiInitialized(true)
        }}
        ref={ppiInjectableRef}
      />
    )
  }

  const display = () => {
    if (mobileScannerEnabled && isMobileScannerInitialized && isCameraPermissionAllowed) {
      return (
        <div className={classNames}>
          {displayVNInjectablePpi()}
          <MobileScanner
            onKeyboardClick={() => {
              setMobileScannerEnabled(false)
              // have to use a timeout or else the keyboard will not show up
              setTimeout(() => {
                qrCodeRef?.current?.focus()
              }, 150)
            }}
            goBack={() => {
              onGoBack(tabOrderInState, order, fromBalanceLookup, cfdMode === MODES.POS)
            }}
            textDisplay={primaryText}
            toolTipText={isProcessing ? 'Processing...' : 'Please scan QR Code'}
            pauseBetweenScansMs={3_000}
          />
          {scanError()}
        </div>
      )
    }

    return (
      <div className={classNames}>
        {displayVNInjectablePpi()}
        <VNConcessionsNavBar
          onClick={() => {
            closeKeyBoard()
            setTimeout(() => {
              onGoBack(tabOrderInState, order, fromBalanceLookup, cfdMode === MODES.POS)
            }, 200)
          }}
          rightAccessory={isCameraPermissionAllowed && isMobileScannerInitialized && <CameraAlt onClick={onMobileCameraClick} />}
          textDisplay={isMobile && primaryText}
        />
        <GratuityHeader
          className={cn(styles.gratuityHeader, {
            [styles.fromBalanceLookup]: fromBalanceLookup && !isMobile,
          })}
          primaryText={isMobile ? '' : primaryText}
          secondaryText={secondaryText}
        />
        {!isMobile && (
          <div className={styles.scanScreen__submissionChoices}>
            <SegmentedControlV2
              className={styles.segmentedControl}
              items={QRChoices}
              selectedValue={selectedSubmissionType}
              onSelect={handleSubmissionTypeChange}
            />
          </div>
        )}
        <div className={styles.scanScreen__body}>
          <div className={styles.choicesContent}>
            <div
              className={cn(styles.option, {
                [styles.isHidden]: selectedSubmissionType === 'entry' || isProcessing,
              })}
            >
              <img src={ScanQRGif} alt={'Scan QR'} className={styles.qrImage} />
            </div>
            <div
              className={cn(styles.option, {
                [styles.isHidden]: selectedSubmissionType === 'scan' || isProcessing,
              })}
            >
              <input
                className={styles.manualEntry}
                ref={qrCodeRef}
                value={qrCode}
                onChange={handleTicketCodeChange}
                onKeyDown={handleKeyPress}
                autoFocus
              />
            </div>
            <div
              className={cn(styles.processing, {
                [styles.isHidden]: !isProcessing,
              })}
            >
              <div className={styles.loadingSpinner}>
                <VNLoader processing />
              </div>
              <span className={styles.topText}>Processing...</span>
              <span className={styles.bottomText}>please wait.</span>
            </div>
          </div>
          {chooseTenderOptionButton}
        </div>
      </div>
    )
  }

  return display()
}

const mapStateToProps = (state, props) => {
  const fromBalanceLookup = props?.history?.location?.state?.fromBalanceLookup
  const tipAmount = props?.history?.location?.state?.tip
  const charityAmount = props?.history?.location?.state?.charityAmount
  const order = getOrderInProgress(state)

  const balanceDueInCents = order?.balanceDueInCents
  const push = props?.history?.push ?? (() => {})

  // order would only exist in order list state if being a tabbed order
  const tabOrderInState = getOrder(state, order.uuid)

  return {
    order,
    fromBalanceLookup,
    needCreateOrder: isEmpty(order),
    balanceDueInCents,
    push,
    tabOrderInState,
    tipAmount,
    charityAmount,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const goBack = props?.history?.goBack ?? (() => {})

  return {
    onGoBack: (tabOrderInState, order, fromBalanceLookup, isCfdCompanionPos) => {
      if (fromBalanceLookup) {
        sendCFDScreenNav(CFD_SCREEN.IDLE)
        dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.UNSET, true))
        goBack()
        return
      }

      if (order?.previousAuthorizationFailedStatus) {
        dispatch(restoreQRPaymentandAuthorizationFailedStatus(order?.uuid))
      }
      dispatch(cancelRemovePayment())

      if (isEmpty(tabOrderInState)) {
        dispatch(clearOrderInProgress())
      } else {
        dispatch(clearTipOrderInProgress(tabOrderInState))
        dispatch(clearTipFromOrder(tabOrderInState.uuid))
      }

      if (isCfdCompanionPos) {
        sendCFDScreenNav(CFD_SCREEN.IDLE)
      }
      dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.UNSET, true))
      goBack()
    },
    addPaymentToOrderInProgress: (payment) => dispatch(addPaymentToOrderInProgress(payment)),
    placeFreeOrder: (payload) => {
      dispatch(closeNoOpTender(payload))
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QRPay))
